import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from "@angular/common/http";
import { Injectable } from "@angular/core";

import {
  HttpActivityService,
  SKIP_HTTP_ACTIVITY,
} from "@core/services/http-activity.service";
import { finalize, Observable } from "rxjs";

/**
 * Counts every request while it is in flight - including one replayed after a
 * token refresh, since this sits outside the auth interceptor. Settles on
 * success, error and cancellation alike.
 */
@Injectable()
export class HttpActivityInterceptor implements HttpInterceptor {
  constructor(private readonly activity: HttpActivityService) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    if (request.context.get(SKIP_HTTP_ACTIVITY)) {
      return next.handle(request);
    }
    const settle = this.activity.start(request.method);
    return next.handle(request).pipe(finalize(settle));
  }
}
